import sectionReviewGrid04Css from '../css-snippets/section-review-grid-04';

const html = `
<style>${sectionReviewGrid04Css}</style>
<div
  id="review-grid-wrapper-unique-id"
  class="review-grid-wrapper"
  data-attribute="review-grid-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-primary-color="#14a16c"
  data-tag-background-color="#ebeced"
  data-tag-text-color="#000000"
  data-tag-active-text-color="#ffffff"
  data-tag-border-radius="0"
  data-button-text-color="#ffffff"
  data-button-border-radius="24"
  data-avatar-size-mobile="150"
  data-avatar-size-mobile="200"
  data-items-per-row-mobile="1"
  data-items-per-row-desktop="2"
  data-show-tags="true"
  data-page-size="4"
  data-text-line-clamp="2"
  data-reviews-list-background-color="#f5f6f7"
  data-show-avatar-border="true"
  data-show-tags="true"
  style="
    --background-color: #ffffff;
    --text-color: #000000;
    --primary-color: #14a16c;
    --tag-background-color: #ebeced;
    --tag-text-color: #000000;
    --tag-active-text-color: #ffffff;
    --tag-border-radius: 0;
    --button-text-color: #ffffff;
    --button-border-radius: 24px;
    --avatar-width: 200px;
    --avatar-size-mobile: 150px;
    --avatar-size-desktop: 200px;
    --items-per-row-mobile: 1;
    --items-per-row-desktop: 2;
    --reviews-list-background-color: #f5f6f7;
    --text-line-clamp: 2;
  "
>
  <div
    class="review-grid-container-wrapper"
    data-attribute="review-grid-container"
  >
    <div class="review-grid-header container" data-attribute="review-grid-header">
      <div class="review-header" data-attribute="review-header">
        <h2 style="text-align: center">
          <strong>READ WHAT OUR CUSTOMERS HAVE TO SAY</strong>
        </h2>
        <p style="text-align: center">
          *DISCLAIMER: The customer reviews below represent individual results
          and opinions, individual outcomes may vary.
        </p>
      </div>
      <div class="review-tags" data-attribute="review-tags">
        <div class="review-tag-item active" data-attribute="review-tag-item">
          All
        </div>
        <div class="review-tag-item" data-attribute="review-tag-item" data-tag="tag-1">
          Tag 1
        </div>
      </div>
    </div>
    <div class="review-grid-items-wrapper">
      <div class="review-grid-items container" data-attribute="review-grid-items">
        <!-- review items -->
      </div>
      <div class="load-more-button-wrapper">
        <button
          type="button"
          data-attribute="load-more-button"
          class="load-more-button"
        >
          Load more
        </button>
      </div>
    </div>
  </div>
</div>
`;
export default html;
